






















































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import { applicationFormModule } from '../../Uketsuke/store/modules/ApplicationForm';
import { UketsukeConstants } from '../../Uketsuke/fixed/UketsukeConstants';
@Component
export default class VariableTableListActualperformance extends Vue {
  @Prop() private variableList!: any;
  // 業者種別
  private traderType = applicationFormModule.GET_APP_TYPE;
  // 比較用業者種別（工事）
  private traderTypeConst = UketsukeConstants.APP_FORM_CONST;
}
